var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTimerPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/timer-pause"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timer-pause"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0026 19.5018C5.63594 19.5018 2.08594 15.9518 2.08594 11.5851C2.08594 7.21846 5.63594 3.66846 10.0026 3.66846C14.3693 3.66846 17.9193 7.21846 17.9193 11.5851C17.9193 11.9268 17.6359 12.2101 17.2943 12.2101C16.9526 12.2101 16.6693 11.9268 16.6693 11.5851C16.6693 7.91012 13.6776 4.91846 10.0026 4.91846C6.3276 4.91846 3.33594 7.91012 3.33594 11.5851C3.33594 15.2601 6.3276 18.2518 10.0026 18.2518C10.3443 18.2518 10.6276 18.5351 10.6276 18.8768C10.6276 19.2185 10.3443 19.5018 10.0026 19.5018Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 12.0016C9.65833 12.0016 9.375 11.7183 9.375 11.3766V7.20996C9.375 6.86829 9.65833 6.58496 10 6.58496C10.3417 6.58496 10.625 6.86829 10.625 7.20996V11.3766C10.625 11.7183 10.3417 12.0016 10 12.0016Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5 2.83496H7.5C7.15833 2.83496 6.875 2.55163 6.875 2.20996C6.875 1.86829 7.15833 1.58496 7.5 1.58496H12.5C12.8417 1.58496 13.125 1.86829 13.125 2.20996C13.125 2.55163 12.8417 2.83496 12.5 2.83496Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.8359 18.6683C15.4943 18.6683 15.2109 18.385 15.2109 18.0433V14.71C15.2109 14.3683 15.4943 14.085 15.8359 14.085C16.1776 14.085 16.4609 14.3683 16.4609 14.71V18.0433C16.4609 18.385 16.1776 18.6683 15.8359 18.6683Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.3359 18.6683C12.9943 18.6683 12.7109 18.385 12.7109 18.0433V14.71C12.7109 14.3683 12.9943 14.085 13.3359 14.085C13.6776 14.085 13.9609 14.3683 13.9609 14.71V18.0433C13.9609 18.385 13.6776 18.6683 13.3359 18.6683Z",
    fill: "#606060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimerPause);
export default __webpack_public_path__ + "static/media/ic_timer_pause.a7e086fa81e8245a98a56220d8d2bcbf.svg";
export { ForwardRef as ReactComponent };